const currencies = [
  {
    symbol: 'AU$',
    name: 'Australian Dollar',
    symbol_native: '$',
    code: 'AUD',
  },
  {
    symbol: 'CA$',
    name: 'Canadian Dollar',
    symbol_native: '$',
    code: 'CAD',
  },
  {
    symbol: 'CHF',
    name: 'Swiss Franc',
    symbol_native: 'CHF',
    code: 'CHF',
  },
  {
    symbol: '€',
    name: 'Euro',
    symbol_native: '€',
    code: 'EUR',
  },
  {
    symbol: '£',
    name: 'British Pound Sterling',
    symbol_native: '£',
    code: 'GBP',
  },
  {
    symbol: '¥',
    name: 'Japanese Yen',
    symbol_native: '￥',
    code: 'JPY',
  },
  {
    symbol: 'NZ$',
    name: 'New Zealand Dollar',
    symbol_native: '$',
    code: 'NZD',
  },
  {
    symbol: '$',
    name: 'US Dollar',
    symbol_native: '$',
    code: 'USD',
  },
  {
    symbol: 'R',
    name: 'African Rand',
    symbol_native: 'R',
    code: 'ZAR',
  },
];

export default currencies;
